import { ReactNode } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';
import edit from '../../../../../assets/images/icons/edit.svg';
import qrCode from '../../../../../assets/images/icons/qrCode.svg';
import trash from '../../../../../assets/images/icons/trash.svg';
import {
  Card,
} from '../../../../../components/Lists';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { MappedVehicleType } from '../../types';

interface ListInterface {
  filteredVehicles: MappedVehicleType[];
  roles: { [key: string]: ReactNode };
  handleOpenVehicleQrCodeModal: (vehicle: MappedVehicleType) => void;
  handleOpenDeleteVehicleModal: (vehicle: MappedVehicleType) => void;
}

export default function List({
  filteredVehicles,
  roles,
  handleOpenVehicleQrCodeModal,
  handleOpenDeleteVehicleModal,
}: ListInterface) {
  const { permissions } = useGetGeneralAppData();
  const affreightmentsVehiclesPermissions = permissions.find((x) => x.codPag === 11);

  return (
    <Container>
      <Row xs={1} md={1} lg={2}>
        {filteredVehicles?.map((vehicle) => (
          <Col key={vehicle.vehicleId}>
            <OpacityAnimation delay={0.1}>
              <Card>
                <div className="info">
                  <div className="card-title">
                    <strong>{vehicle.vehicleCode}</strong>
                    {vehicle.transportType && (
                      roles[vehicle.transportType]
                    )}
                  </div>
                  <span>
                    {vehicle.brand}
                    {' '}
                    {vehicle.model}
                  </span>
                  <span>
                    {vehicle.capacity}
                    {' '}
                    lugares
                  </span>
                  <span>
                    {vehicle.consumption}
                    {' '}
                    km/L
                  </span>
                </div>

                <div className="actions">

                  <button type='button' onClick={() => handleOpenVehicleQrCodeModal(vehicle)}>
                    <img src={qrCode} alt="edit" title="QR Code do veículo" />
                  </button>

                  {affreightmentsVehiclesPermissions?.alterar && (
                    <Link to={`/vehicles/${vehicle.vehicleId}`}>
                      <img src={edit} alt="edit" title="Editar veículo" className='primaryColor' />
                    </Link>
                  )}

                  {affreightmentsVehiclesPermissions?.excluir && (
                    <button type='button' onClick={() => handleOpenDeleteVehicleModal(vehicle)}>
                      <img src={trash} alt="edit" title="Excluir veículo" />
                    </button>
                  )}
                </div>

              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
